import { FC } from "react";
import StartScreen from "../app/startscreen/StartScreen.component";

const StartPage: FC = () => <StartScreen />

export default StartPage;